
const LinkIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5.25008 9.91667H4.08341C3.30987 9.91667 2.568 9.60937 2.02102 9.06239C1.47404 8.51541 1.16675 7.77355 1.16675 7C1.16675 6.22645 1.47404 5.48459 2.02102 4.9376C2.568 4.39062 3.30987 4.08333 4.08341 4.08333H5.25008" stroke="#175CD3" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.75 4.08333H9.91667C10.6902 4.08333 11.4321 4.39062 11.9791 4.9376C12.526 5.48459 12.8333 6.22645 12.8333 7C12.8333 7.77355 12.526 8.51541 11.9791 9.06239C11.4321 9.60937 10.6902 9.91667 9.91667 9.91667H8.75" stroke="#175CD3" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.66675 7H9.33341" stroke="#175CD3" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default LinkIcon